import { useQueries } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import { handleEssSSRState, selectEssSwitch } from "../components/store/slices/essSwitchSlice";
import { selectDescription } from "../components/store/slices/ssrDescriptionSlice";
import { handleTesSSRState, selectTesSwitch } from "../components/store/slices/tesSwitchSlice";
import { getSSRsForDeviceService } from "../services";
import { buildSpecsFromHeaters } from "../helpers/buildSpecsFromHeaters";

// Pairs every machine with its own location and machine key, so the two can
// never drift apart the way a filtered array index does.
// faultedOnly: the faults page only needs machines with an active SSR fault;
// report status needs all of them, or its per-SSR report stays empty.
export const getSSRFetchTargets = (switchStatus, { faultedOnly = true } = {}) =>
  Object.entries(switchStatus).flatMap(([location, zone]) =>
    Object.entries(zone)
      .filter(([, machine]) => !faultedOnly || machine.ssrFault?.includes(1))
      .map(([machineKey, machine]) => ({ location, machineKey, machine }))
  );

export const useGetAllSSRsQueries = (switchStatus, swtName, options) => {
  const dispatch = useDispatch();
  const { elementsOptions } = useSelector(selectDescription);
  const { flatEssSwitch, flatTesSwitch } = useSelector(
    swtName === 'ESS'
      ? selectEssSwitch
      : selectTesSwitch
  );

  const swtStatus = swtName === 'ESS' ? flatEssSwitch : flatTesSwitch;

  const getSSRsQueries = useQueries(
    getSSRFetchTargets(switchStatus, options)
      .map(({ location, machineKey: machine, machine: machineData }) => ({
            queryKey: [machineData.deviceMac, '-ssrsData'],
            queryFn: () => getSSRsForDeviceService(machineData.deviceMac),
            onSuccess: (data) => {
              if (data) {
                const result = data.map((item) => {
                  const specs = buildSpecsFromHeaters(item.Heaters, elementsOptions);
                  return {
                    ...item,
                    select: `tc-${swtStatus[location]?.[machine]?.heaterThermocoupleMap?.[item.No]}`,
                    buttonStatus: item?.fault === true || item?.Load_exceeded === true ? 'flt' :
                      item?.active === true ? 'on' : 'off',
                    specs: specs.length !== 0 ? specs : [{}],
                    switchName: `${item.name} ${item.size}`,
                  };
                });
                const ssrStateData = {
                  location,
                  machine,
                  data: result,
                }
                if (swtName === 'ESS') {
                  dispatch(handleEssSSRState(ssrStateData));
                } else if (swtName === 'TES') {
                  dispatch(handleTesSSRState(ssrStateData));
                }


              }
            },
            onError: (error) => {
              console.error('get ssrs fail:', error.message);
            },
          }))
  );

  return getSSRsQueries;
};